import { httpPost, httpGet } from "./dataService"

async function getUserNotifications({
  jeweller,
  user,
  notificationType,
  page,
  limit,
  search,
}) {
  const params = new URLSearchParams();

  if (notificationType) params.append("notificationType", notificationType);
  if (page) params.append("page", page);
  if (limit) params.append("limit", limit);
  if (search) params.append("search", search);

  const queryString = params.toString();

  return await httpGet(
    `/api/v1/notification/getnotificationbyuser/${jeweller}/${user}${
      queryString ? `?${queryString}` : ""
    }`,
    {},
  );
}

async function sendNotification({data}) {
    return await httpPost(`/api/v1/notification/send`,data, {})
}

async function updateNotification(data){
    return await httpPost(`/api/v1/notification/updatenotification`, data, {})
}

async function bulkNotificationUpload(formData) {
  return await httpPost(
    `/api/v1/notification/upload`,
    formData,
    {}
  );
}

export {getUserNotifications, sendNotification, updateNotification,bulkNotificationUpload}